import { ICompany } from '@App/app/entities/admin-panel/company.model';
import { createAction, props } from '@ngrx/store';

export const loadUserCompanies = createAction('[User Companies] Load User Companies');

export const loadUserCompaniesSuccess = createAction(
  '[User Companies] Load User Companies Success',
  props<{ companies: ICompany[] }>(),
);

export const loadUserCompaniesFailure = createAction(
  '[User Companies] Load User Companies Failure',
);
